// extracted by mini-css-extract-plugin
export var aircallIframe = "_m8-3";
export var fabContainer = "_m8-5";
export var fabRinging = "_m8-6";
export var loadingOverlay = "_m8-4";
export var pulse = "_m8-7";
export var widgetContent = "_m8-2";
export var widgetPanel = "_m8-0";
export var widgetPanelExpanded = "_m8-1";